import _regeneratorRuntime from "/builds/7ChVgkMg/0/gcp-backend/tea-h5/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/builds/7ChVgkMg/0/gcp-backend/tea-h5/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.object.to-string.js";
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, resolveComponent as _resolveComponent, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, normalizeStyle as _normalizeStyle } from "vue";
var _hoisted_1 = {
  class: "content-container"
};
var _hoisted_2 = {
  class: "title"
};
var _hoisted_3 = {
  class: "subtitle"
};
var _hoisted_4 = {
  key: 0,
  class: "login-btns"
};
var _hoisted_5 = {
  key: 1,
  class: "coming"
};
import { useRouter } from "@/hooks/useRouter";
import { useSupplierStore } from "@/store/supplierStore";
import { useUserStore } from "@/store/userStore";
import defaultLoginImage from "@/assets/images/login/background.png";
import { onMounted, ref } from "vue";
import GoogleSignInButton from "@/components/login/GoogleSignInButton.vue";
import AppleSignInButton from "@/components/login/AppleSignInButton.vue";
import MobileSignInButton from "@/components/login/MobileSignInButton.vue";
export default {
  __name: 'LoginView',
  setup: function setup(__props) {
    var _useRouter = useRouter(),
      routerPush = _useRouter.routerPush;
    var supplierStore = useSupplierStore();
    var userStore = useUserStore();
    var handleGoogleLoginCompleted = function handleGoogleLoginCompleted(res) {
      userStore.thirdLogin({
        token: res.token,
        third_platform: "google"
      }).then(function () {
        routerPush({
          name: "Index"
        });
      });
    };
    var handleAppleLoginCompleted = function handleAppleLoginCompleted(data) {
      userStore.thirdLogin({
        token: data.id_token,
        third_platform: "apple"
      }).then(function () {
        routerPush({
          name: "Index"
        });
      });
    };
    var handleMoblieLoginCompleted = function handleMoblieLoginCompleted() {
      routerPush({
        name: "Index"
      });
    };
    var loginBackground = ref("");
    function loadImg() {
      return _loadImg.apply(this, arguments);
    }
    function _loadImg() {
      _loadImg = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
        return _regeneratorRuntime().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              _context3.next = 2;
              return new Promise(function (resolve, reject) {
                var img = new Image();
                img.src = supplierStore.getLoginBackgroundImage || defaultLoginImage;
                img.onload = /*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
                  return _regeneratorRuntime().wrap(function _callee$(_context) {
                    while (1) switch (_context.prev = _context.next) {
                      case 0:
                        resolve(true);
                        loginBackground.value = img.src;
                      case 2:
                      case "end":
                        return _context.stop();
                    }
                  }, _callee);
                }));
                img.onerror = /*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
                  return _regeneratorRuntime().wrap(function _callee2$(_context2) {
                    while (1) switch (_context2.prev = _context2.next) {
                      case 0:
                        resolve(false);
                      case 1:
                      case "end":
                        return _context2.stop();
                    }
                  }, _callee2);
                }));
              });
            case 2:
            case "end":
              return _context3.stop();
          }
        }, _callee3);
      }));
      return _loadImg.apply(this, arguments);
    }
    onMounted(function () {
      loadImg();
    });
    return function (_ctx, _cache) {
      var _component_Gap = _resolveComponent("Gap");
      return _openBlock(), _createElementBlock("div", {
        class: "login-container",
        style: _normalizeStyle("background-image: url(".concat(loginBackground.value, ")"))
      }, [_createElementVNode("div", _hoisted_1, [_createElementVNode("p", _hoisted_2, _toDisplayString(_ctx.$t("welcomeToStartNow", [_unref(supplierStore).getSupplierName])), 1), _createElementVNode("p", _hoisted_3, _toDisplayString(_ctx.$t("orderingRewardsLoyaltyMembershipsAndMore")), 1), _unref(supplierStore).getIsLoginOpen ? (_openBlock(), _createElementBlock("div", _hoisted_4, [_unref(supplierStore).getIsGoogleLoginOpen ? (_openBlock(), _createElementBlock(_Fragment, {
        key: 0
      }, [_createVNode(GoogleSignInButton, {
        id: "google-sign-in-btn",
        onSuccess: handleGoogleLoginCompleted
      }), _createVNode(_component_Gap, {
        h: 0.1
      })], 64)) : _createCommentVNode("", true), _unref(supplierStore).getIsAppleLoginOpen ? (_openBlock(), _createElementBlock(_Fragment, {
        key: 1
      }, [_createVNode(AppleSignInButton, {
        onSuccess: handleAppleLoginCompleted
      }), _createVNode(_component_Gap, {
        h: 0.1
      })], 64)) : _createCommentVNode("", true), _unref(supplierStore).getIsMobileLoginOpen ? (_openBlock(), _createBlock(MobileSignInButton, {
        key: 2,
        onSuccess: handleMoblieLoginCompleted
      })) : _createCommentVNode("", true)])) : (_openBlock(), _createElementBlock("div", _hoisted_5, _toDisplayString(_ctx.$t("comingSoon")), 1))])], 4);
    };
  }
};